var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.1972 9.50625C22.016 4.30875 17.4822 1.96875 13.4997 1.96875C13.4997 1.96875 13.4997 1.96875 13.4885 1.96875C9.51724 1.96875 4.97224 4.2975 3.79099 9.495C2.47474 15.3 6.02974 20.2162 9.24724 23.31C10.4397 24.4575 11.9697 25.0312 13.4997 25.0312C15.0297 25.0312 16.5597 24.4575 17.741 23.31C20.9585 20.2162 24.5135 15.3112 23.1972 9.50625Z",
    fill: "#75DBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 15.1427C15.457 15.1427 17.0436 13.5561 17.0436 11.5989C17.0436 9.64177 15.457 8.05518 13.4998 8.05518C11.5426 8.05518 9.95605 9.64177 9.95605 11.5989C9.95605 13.5561 11.5426 15.1427 13.4998 15.1427Z",
    fill: "#75DBDB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5f2976f9e26680093ef6089fe0a23000.svg";
export { ForwardRef as ReactComponent };